import { Navigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

/**
 * AgentRouteGuard — guards the dedicated Handover Agent console at
 * /agent-dashboard. Owners/admins/anonymous users are bounced to the
 * dashboard that matches their role so there is no cross-leak of handover
 * data into other surfaces.
 */
export default function AgentRouteGuard({ children }) {
  const { user, loading } = useAuth()

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary-600"></div>
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/login" replace />
  }

  const adminToken = localStorage.getItem('admin_auth_token')
  if (user.isAdmin || adminToken) {
    return <Navigate to="/dashboard" replace />
  }

  if (user.role !== 'handover_agent') {
    return <Navigate to="/customer-dashboard" replace />
  }

  return children
}
